__webpack_require__.p = "https://observations.ipsl.fr/aeris/magic/";